import { render, staticRenderFns } from "./NodeContentViewer.vue?vue&type=template&id=254a808c&scoped=true&"
import script from "./NodeContentViewer.vue?vue&type=script&lang=js&"
export * from "./NodeContentViewer.vue?vue&type=script&lang=js&"
import style0 from "./NodeContentViewer.vue?vue&type=style&index=0&id=254a808c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254a808c",
  null
  
)

export default component.exports